"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var AppParamsHelper_1 = require("../helpers/AppParamsHelper");
var collection_1 = require("../utils/collection");
var object_1 = require("../utils/object");
var script_1 = require("../utils/script");
var utils_1 = require("./utils");
exports.EVENTS = {
    KSYS_APP_LOADED: 'ksys-app-loaded',
    KSYS_APPS_LOADED: 'ksys-apps-loaded',
    KSYS_APP_EMBED_ADDED: 'ksys-app-embed-added',
};
var AppsManager = /** @class */ (function () {
    function AppsManager(manifest, appHydration, externalScriptsBasePath) {
        this.manifest = manifest;
        this.appHydration = appHydration;
        this.externalScriptsBasePath = externalScriptsBasePath;
    }
    AppsManager.prototype.initialize = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var initializeAppRequests, getApplications, externalScriptOptions, assetRegisterCacheOptions, appsRenderOptions, group, environment, templateIds, elements, appsRequest, appsRequests, appsResponses, _a, appsResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        initializeAppRequests = options.initializeAppRequests, getApplications = options.getApplications, externalScriptOptions = options.externalScriptOptions, assetRegisterCacheOptions = options.assetRegisterCacheOptions, appsRenderOptions = options.appsRenderOptions, group = options.group;
                        environment = process.env.NODE_ENV;
                        templateIds = group && group.apps ? group.apps.map(function (app) { return app.templateId; }) : undefined;
                        elements = this.getAppEmbedNodes(templateIds, function (element) { return !element.dataset.managerInitialized; });
                        if (!(elements && elements.length > 0)) return [3 /*break*/, 6];
                        appsRequest = this.getAppsRequest(options, false, elements);
                        if (!(appsRequest && appsRequest.apps && appsRequest.apps.length > 0)) return [3 /*break*/, 6];
                        appsRequests = this.splitAppsRequest(appsRequest);
                        _a = initializeAppRequests;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, initializeAppRequests(appsRequests)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        appsResponses = (_a) || [];
                        appsResponse = this.appHydration.mergeAppsResponses(appsResponses.filter(function (appResponse) { return !(appResponse instanceof Error); }));
                        this.setInputsOnEmbedContainers(options, elements);
                        if (!appsResponse) return [3 /*break*/, 3];
                        this.mergeMasterStylesAndConfigurations(appsResponse);
                        this.appHydration.setHydrationPoint(appsResponse);
                        this.loadAppsResponseScripts(appsResponse, externalScriptOptions, assetRegisterCacheOptions, appsRenderOptions);
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.loadAppScriptsForAppsRequest(appsRequest, getApplications, externalScriptOptions)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        elements.forEach(function (element) {
                            if (element.dataset.ksysAppTemplateId !== 'ksys-app-manager') {
                                element.dataset.managerInitialized = 'true';
                            }
                        });
                        _b.label = 6;
                    case 6: return [2 /*return*/, { elements: elements }];
                }
            });
        });
    };
    AppsManager.prototype.isManagerAppNode = function (appParamsHelper) {
        var templateId = this.manifest.ksysAppTemplateId;
        var templateIdWithVersion = this.manifest.ksysAppTemplateId + "-v" + this.manifest.version;
        var ksysAppTemplateId = appParamsHelper.rawAppParams.ksysAppTemplateId;
        return [templateId, templateIdWithVersion].includes(ksysAppTemplateId);
    };
    AppsManager.prototype.orchestrateAppFromAppParams = function (appParams, includeInputs, appVersions) {
        if (includeInputs === void 0) { includeInputs = false; }
        var rawAppParams = appParams.rawAppParams;
        var ksysAppTemplateId = rawAppParams.ksysAppTemplateId, applicationCode = rawAppParams.applicationCode, configurationKey = rawAppParams.configurationKey, styleKey = rawAppParams.styleKey, ksysAppTemplateVersion = rawAppParams.ksysAppTemplateVersion;
        var app = {
            templateId: ksysAppTemplateId,
        };
        if (applicationCode) {
            app.applicationCode = applicationCode;
        }
        if (configurationKey) {
            app.configurationKey = configurationKey;
        }
        if (styleKey) {
            app.styleKey = styleKey;
        }
        if (ksysAppTemplateVersion) {
            app.version = ksysAppTemplateVersion;
        }
        else if (appVersions && appVersions[ksysAppTemplateId]) {
            app.version = appVersions[ksysAppTemplateId];
            if (!app.version.startsWith('v')) {
                app.version = "v" + app.version;
            }
        }
        if (includeInputs) {
            app.inputs = appParams.values && appParams.values.inputs;
        }
        return app;
    };
    AppsManager.prototype.getAppEmbedNodes = function (templateIds, additionalFilterFn) {
        var ksysAppTemplateIdDataKey = 'data-ksys-app-template-id';
        var elements = document.querySelectorAll("[" + ksysAppTemplateIdDataKey + "]");
        var response = Array.from(elements);
        if (templateIds && templateIds.length > 0) {
            response = response.filter(function (element) {
                var ksysAppTemplateId = element.dataset.ksysAppTemplateId;
                return ksysAppTemplateId === 'ksys-app-manager' || templateIds.includes(ksysAppTemplateId);
            });
        }
        return response.filter(function (element) { return !element.dataset.initialized && (!additionalFilterFn || additionalFilterFn(element)); });
    };
    AppsManager.prototype.getAppsRequest = function (options, includeInputs, elements) {
        var _this = this;
        if (includeInputs === void 0) { includeInputs = false; }
        var url = options.url, appsRequestOptions = options.appsRequestOptions, group = options.group, appVersions = options.appVersions;
        var appsRequest = {
            options: appsRequestOptions,
            apps: [],
        };
        if (!elements) {
            var templateIds = group && group.apps ? group.apps.map(function (app) { return app.templateId; }) : undefined;
            elements = this.getAppEmbedNodes(templateIds, function (element) { return !element.dataset.managerInitialized; });
        }
        if (elements && elements.length > 0) {
            var appParamHelpers = elements.map(function (element) { return new AppParamsHelper_1.AppParamsHelper(element, url); });
            var managerAppParams = appParamHelpers.find(function (appParamsHelper) {
                return _this.isManagerAppNode(appParamsHelper);
            });
            if (managerAppParams) {
                appsRequest.manager = this.orchestrateAppFromAppParams(managerAppParams, includeInputs);
                if (managerAppParams.values &&
                    managerAppParams.values.inputs &&
                    managerAppParams.values.inputs.culture) {
                    if (!appsRequest.options) {
                        appsRequest.options = {};
                    }
                    appsRequest.options.culture = managerAppParams.values
                        .inputs.culture;
                }
            }
            var otherAppParams = appParamHelpers.filter(function (appParamsHelper) { return !_this.isManagerAppNode(appParamsHelper); });
            for (var _i = 0, otherAppParams_1 = otherAppParams; _i < otherAppParams_1.length; _i++) {
                var appParams = otherAppParams_1[_i];
                var app = this.orchestrateAppFromAppParams(appParams, includeInputs, appVersions);
                if (!appsRequest.apps) {
                    appsRequest.apps = [];
                }
                if (appsRequest.apps) {
                    appsRequest.apps.push(app);
                }
            }
        }
        return appsRequest;
    };
    AppsManager.prototype.setInputsOnEmbedContainers = function (options, elements) {
        var appsRequest = this.getAppsRequest(options, true, elements);
        var manager = appsRequest.manager, _a = appsRequest.apps, apps = _a === void 0 ? [] : _a;
        if (manager) {
            for (var _i = 0, apps_1 = apps; _i < apps_1.length; _i++) {
                var app = apps_1[_i];
                if (app) {
                    app.inputs = Object.assign({}, manager.inputs || {}, app.inputs || {});
                }
            }
            var _loop_1 = function (app) {
                if (app && app.inputs) {
                    var inputs = Object.keys(app.inputs).reduce(function (acc, inputKey) {
                        var key = "input" + inputKey
                            .substr(0, 1)
                            .toUpperCase() + inputKey.substr(1);
                        var value = app.inputs[inputKey];
                        acc[key] = value;
                        return acc;
                    }, {});
                    var elements_2 = utils_1.getElementsForAppInstance(app);
                    if (elements_2 && elements_2.length > 0) {
                        for (var _i = 0, elements_1 = elements_2; _i < elements_1.length; _i++) {
                            var element = elements_1[_i];
                            if (!element.dataset.ksysAppTemplateVersion && app.version) {
                                element.dataset.ksysAppTemplateVersion = app.version;
                            }
                            for (var _a = 0, _b = Object.keys(inputs); _a < _b.length; _a++) {
                                var key = _b[_a];
                                element.dataset[key] = inputs[key];
                            }
                        }
                    }
                }
            };
            for (var _b = 0, _c = appsRequest.apps || []; _b < _c.length; _b++) {
                var app = _c[_b];
                _loop_1(app);
            }
        }
    };
    AppsManager.prototype.mergeMasterStylesAndConfigurations = function (appsResponse) {
        var _a = appsResponse.apps, apps = _a === void 0 ? [] : _a, manager = appsResponse.manager;
        if (manager) {
            for (var _i = 0, apps_2 = apps; _i < apps_2.length; _i++) {
                var appResponse = apps_2[_i];
                if (appResponse) {
                    appResponse.applicationConfiguration = object_1.deepMergeObjects(manager.applicationConfiguration || {}, appResponse.applicationConfiguration || {});
                    appResponse.applicationStyles = object_1.deepMergeObjects(manager.applicationStyles || {}, appResponse.applicationStyles || {});
                }
            }
        }
    };
    AppsManager.prototype.splitAppsRequest = function (originalAppsRequest, maxLength) {
        if (maxLength === void 0) { maxLength = 1900; }
        var appsRequest = object_1.deepMergeObjects({}, originalAppsRequest);
        var response = [];
        var options = appsRequest.options;
        if (maxLength > 0) {
            var counter = 0;
            var maxCounter = 1000;
            var _a = appsRequest.apps, apps = _a === void 0 ? [] : _a, manager = appsRequest.manager;
            var currentAppsRequest = {
                manager: manager,
                options: options,
                apps: [],
            };
            var workingLength = this.getUrlJsonLength(currentAppsRequest);
            for (var appIndex = 0; appIndex < apps.length; appIndex++) {
                if (workingLength) {
                    var app = apps[appIndex];
                    var appLength = this.getUrlJsonLength(app);
                    if (appLength) {
                        if (appLength + workingLength < maxLength) {
                            if (!currentAppsRequest.apps) {
                                currentAppsRequest.apps = [];
                            }
                            currentAppsRequest.apps.push(app);
                            apps.shift();
                            appIndex--;
                            counter = 0;
                        }
                        else {
                            response.push(currentAppsRequest);
                            var _b = (options ||
                                {}), culture = _b.culture, otherOptions = __rest(_b, ["culture"]);
                            currentAppsRequest = {
                                options: otherOptions,
                                apps: [],
                            };
                            appIndex--;
                            counter++;
                            if (counter > maxCounter) {
                                break;
                            }
                        }
                    }
                    else {
                        apps.shift();
                        appIndex--;
                    }
                }
                workingLength = this.getUrlJsonLength(currentAppsRequest);
            }
            if (currentAppsRequest) {
                response.push(currentAppsRequest);
            }
        }
        else {
            response.push(appsRequest);
        }
        return response;
    };
    AppsManager.prototype.getUrlJsonLength = function (obj) {
        try {
            var str = JSON.stringify(obj);
            if (str && str.length > 0) {
                return encodeURIComponent(str).length;
            }
        }
        catch (ex) {
            console.warn('getUrlJsonLength', ex);
        }
        return undefined;
    };
    AppsManager.prototype.loadAppsResponseScripts = function (appsResponse, externalScriptOptions, assetRegisterCacheOptions, appsRenderOptions) {
        if (appsResponse.javascript) {
            if (typeof appsResponse.javascript === 'string') {
                var scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.innerHTML = appsResponse.javascript;
                var currentScript = this.getCurrentScript();
                if (currentScript && currentScript.parentNode) {
                    currentScript.parentNode.insertBefore(scriptElement, currentScript);
                }
                appsResponse.javascript = 'true';
            }
        }
        else {
            this.loadAppScripts(appsResponse, externalScriptOptions, assetRegisterCacheOptions, appsRenderOptions);
        }
    };
    AppsManager.prototype.loadAppScripts = function (appsResponse, externalScriptOptions, cacheOptions, appsRenderOptions) {
        var apps = appsResponse.apps;
        var scriptUrls = (apps || []).map(function (appResponse) {
            var app = appResponse.app;
            var fileName = "main-" + appResponse.app.templateId + ".js";
            fileName = fileName.replace(/\-v\d{1,5}\.\d{1,5}\.\d{1,5}/, '');
            if (app.assetRegister && app.assetRegister.length > 0) {
                var assetRegister = app.assetRegister.find(function (asset) { return asset.fileName === fileName; });
                if (assetRegister) {
                    fileName = utils_1.appendCacheQueryString(fileName, assetRegister, cacheOptions);
                }
            }
            return {
                app: app,
                url: "/applicationManager/apps/" + appResponse.app.applicationCode + "/" + fileName,
            };
        });
        var baseUrl = this.externalScriptsBasePath || this.manifest.getBaseUrl('');
        renderApps(scriptUrls, baseUrl, externalScriptOptions, appsRenderOptions);
    };
    AppsManager.prototype.loadAppScriptsForAppsRequest = function (appsRequest, getApplications, externalScriptOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var applications, _a, applicationsByApplicationTemplateCode, _b, apps, scriptUrls, baseUrl, _i, scriptUrls_1, scriptUrl;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = getApplications;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, getApplications()];
                    case 1:
                        _a = (_c.sent());
                        _c.label = 2;
                    case 2:
                        applications = (_a) || [];
                        applicationsByApplicationTemplateCode = collection_1.pivotCollection(applications, function (application) { return application.applicationTemplateCode || '_noApplicationTemplateCode'; });
                        _b = appsRequest.apps, apps = _b === void 0 ? [] : _b;
                        scriptUrls = apps.map(function (app) {
                            var templateId = app.templateId, _a = app.version, version = _a === void 0 ? 'v1.0.0' : _a;
                            var applicationTemplateCode = templateId;
                            var applicationTemplateCodeWithVersion = applicationTemplateCode + "-" + version;
                            var application = applicationsByApplicationTemplateCode[applicationTemplateCodeWithVersion] || applicationsByApplicationTemplateCode[applicationTemplateCode];
                            if (application) {
                                var applicationCode = application.applicationCode;
                                var fileName = "main-" + app.templateId + ".js";
                                fileName = fileName.replace(/\-v\d{1,5}\.\d{1,5}\.\d{1,5}/, '');
                                return "/applicationManager/apps/" + applicationCode + "/" + fileName;
                            }
                            console.warn("No application found for: " + applicationTemplateCode + " or " + applicationTemplateCodeWithVersion);
                            return;
                        });
                        baseUrl = this.externalScriptsBasePath || this.manifest.getBaseUrl('');
                        for (_i = 0, scriptUrls_1 = scriptUrls; _i < scriptUrls_1.length; _i++) {
                            scriptUrl = scriptUrls_1[_i];
                            loadScriptWithOptions(scriptUrl, baseUrl, externalScriptOptions);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AppsManager.prototype.getCurrentScript = function () {
        return document.currentScript || (function () {
            var scripts = document.getElementsByTagName('script');
            return scripts[scripts.length - 1];
        })();
    };
    return AppsManager;
}());
exports.AppsManager = AppsManager;
function getAppRegistry() {
    var key = '__ksys-app-registry__';
    if (!window[key]) {
        window[key] = {};
    }
    return window[key];
}
exports.getAppRegistry = getAppRegistry;
function getAppsRenderVariables() {
    var key = '__ksys-app-render-variables__';
    if (!window[key]) {
        window[key] = {};
    }
    return window[key];
}
exports.getAppsRenderVariables = getAppsRenderVariables;
function renderAppsGroup(appsGroup, baseUrl, externalScriptOptions) {
    if (appsGroup) {
        var appsRenderVariables = getAppsRenderVariables();
        var appUrlsByAppKey = appsRenderVariables.appUrlsByAppKey;
        if (appUrlsByAppKey) {
            var apps = appsGroup.apps;
            for (var _i = 0, apps_3 = apps; _i < apps_3.length; _i++) {
                var app = apps_3[_i];
                var appKey = utils_1.getAppKeyRaw(app.templateId, app.configurationKey, app.styleKey, app.version);
                var appsUrl = appUrlsByAppKey[appKey];
                if (appsUrl) {
                    loadScriptWithOptions(appsUrl.url, baseUrl, externalScriptOptions, appKey);
                }
            }
        }
    }
}
exports.renderAppsGroup = renderAppsGroup;
function renderApps(appUrls, baseUrl, externalScriptOptions, appsRenderOptions) {
    if (appUrls) {
        for (var _i = 0, appUrls_1 = appUrls; _i < appUrls_1.length; _i++) {
            var appUrl = appUrls_1[_i];
            loadScriptWithOptions(appUrl.url, baseUrl, externalScriptOptions);
        }
    }
}
exports.renderApps = renderApps;
function removeAppsLoadedEventListener() {
    document.removeEventListener(exports.EVENTS.KSYS_APP_LOADED, window['__ksys-app-handle-app-loaded__']);
}
function loadScriptWithOptions(src, baseUrl, externalScriptOptions, appKey) {
    if (src) {
        try {
            var externalScript = {
                src: src,
                options: externalScriptOptions || {},
            };
            script_1.loadScript(externalScript, baseUrl);
            if (appKey) {
                var appsRenderVariables = getAppsRenderVariables();
                var appUrlsByAppKey = appsRenderVariables.appUrlsByAppKey;
                delete appUrlsByAppKey[appKey];
            }
        }
        catch (ex) {
            console.warn(ex);
        }
    }
}
exports.loadScriptWithOptions = loadScriptWithOptions;
//# sourceMappingURL=AppsManager.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/appsManager/AppsManager.js
// module id = 947
// module chunks = 1